import * as React from 'react'


interface TexasProps { }

const Texas : React.FunctionComponent<TexasProps> = ({}) : JSX.Element => {
    return (
        <div>
            <p>Texas</p>
        </div>
    )
}

export default Texas